import { useTranslation } from "react-i18next";

export const NoResultsFound = () => {
  const { t } = useTranslation();

  return (
    <div className="col-span-2 shrink-0 rounded-xl bg-error-50 py-8 text-center">
      <p className="md:body-lg body-sm text-neutral-950">{t("searchLessonView.noResultsFound")}</p>
    </div>
  );
};
